/**
 * Parse company whitelabelInfo JSON from API (string or object).
 * @returns {object|null}
 */
const parseWhitelabelInfo = (raw) => {
  if (!raw) return null;
  if (typeof raw === "object") return raw;
  if (typeof raw !== "string" || !raw.trim()) return null;
  try {
    return JSON.parse(raw);
  } catch {
    return null;
  }
};

export default parseWhitelabelInfo;
